
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import StepList from "@/components/scope/step-list.vue";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
const inventory = namespace("inventory");
const app = namespace("app");
const setting = namespace("setting");

@InjectFunction("dayjs", "addCurrencyUnit", "emptyToLine", "splitThousands", "permit", "permitApp", "partsPropComb")
@Component({
  components: {
    StepList
  }
})
export default class ServiceView extends Vue {
  @inventory.Action inWarehouseComplete;
  @inventory.Action getInWarehouseDetail;
  @inventory.Action inWarehouseCancel;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.State fifoStatus;
  @setting.State productionBatchNoStatus;
  get breadData() {
    return [
      { name: t("warehouse.inbound-manage"), path: "/inventory/in-warehouse" },
      { name: t("v213.Inbound-detail") }
    ];
  }
  created() {
    this.init();
  }
  handleMoreMenuClick(command) {
    if (command === "cancel") {
      this.inWarehouseCancel({
        inboundNo: this.orderId
      }).then(() => {
        this.$message.success(t("finance.cancel-success") as string);
        this.init();
      });
    }
  }
  get orderId() {
    return this.$route.params.id;
  }
  detailData: any = { inboundStatus: "2", photoList: [] };
  handleComplete() {
    this.inWarehouseComplete({
      inboundNo: this.orderId
    }).then(() => {
      this.$message.success(t("warehouse.inbound-success") as string);
      this.showInConfirmTips = false;
      this.init();
    });
  }
  handleArriveStore() {
    this.$router.push(`/service/arrive/input/${this.orderId}`);
  }

  init() {
    this.getInWarehouseDetail({
      inboundNo: this.orderId
    }).then(data => {
      this.detailData = data.data;
    });
  }
  handleLinkOrderView(orderNo) {
    let { href } = this.$router.resolve({
      path: `/service/view/${orderNo}?tenantCode=${this.detailData.tenantCode || ""}`
    });
    window.open(href, "_blank");
  }
  handleLinkPurchaseView(purchaseNo) {
    let { href } = this.$router.resolve({
      path: `/purchase/purchase-view/${purchaseNo}`
    });
    window.open(href, "_blank");
  }
  showInConfirmTips: boolean = false;
  handleShowInConfrimTips() {
    this.showInConfirmTips = true;
  }
}
